<template>
  <div>
    <div class="label-contract">
      <span style="float: left; margin-bottom: 10px">{{ $t('applyRoomType') }}:</span>
      <span style="float: right; margin-bottom: 10px">
        <el-checkbox v-model="isEnableAllotment"
                     @change="onApplyRoomTypeChange()">
          {{$t('enableAllotment')}}
        </el-checkbox>
      </span>
    </div>
    <table class="table-apply-room-type" border="0" cellspacing="0" cellpadding="0">
      <tr class="table-apply-room-type-header">
        <td width="10%"></td>
        <td width="60%">{{$t('roomTypeName')}}</td>
        <td width="15%" align="center">{{$t('cutoffDate')}}</td>
        <td width="15%" align="center">{{$t('allotment')}}</td>
      </tr>
      <tr v-for="(roomType, index) of promotionRoomTypeListDataSource" :key="`roomType-${index}`"
          class="table-apply-room-type-body"
          :class="{ 'row-disabled': isRoomTypeDisable(roomType) }"
          v-show="roomType.isEnable === STATUS.ENABLE || showRoomTypeDisable(roomType)">
        <td width="10%" align="center">
          <el-checkbox v-model="applyRoomTypeCheckboxList[index].isCheck"
                       :disabled="roomType.isEnable === STATUS.DISABLE"
                       @change="onApplyRoomTypeChange">
          </el-checkbox>
        </td>
        <td width="60%">
          <div>
            {{ (!roomType.name) ? $t('deleted') : roomType.name }}
          </div>
          <div class="contract-data-version" style="margin: 0" v-if="isUpdatedData(promotionRoomTypeList, roomType)">
            <div class="contract-data-updated">
              <div style="padding: 20px 0 0 20px">
                <strong>*{{$t('updatedRoomTypeMessage')}}</strong>
              </div>
              <el-radio-group style="padding-left: 40px" v-model="applyRoomTypeCheckboxList[index].version" fill="#ff0000" @change="onApplyRoomTypeChange()">
                <div class="contract-data-version-radio">
                  <el-radio :label="DATA_VERSION.SELECTED">{{$t('selectedVersion')}} ({{bindUpdatedAt(roomType.updatedAt)}})</el-radio>
                </div>
                <div class="contract-data-version-radio">
                  <el-radio :label="DATA_VERSION.LATEST">{{$t('latestVersion')}} ({{bindLatestUpdatedAt(roomType.id)}})</el-radio>
                </div>
              </el-radio-group>
            </div>
          </div>
          <div class="contract-data-version" style="margin: 0" v-if="isDeletedData(promotionRoomTypeList, roomType.id)">
            <div class="contract-data-deleted">
              <div style="padding: 20px 0 0 20px">
                <strong style="color: #dd3333">*{{$t('deletedRoomTypeMessage')}}</strong>
              </div>
              <el-radio-group style="padding-left: 40px" v-model="roomType.id" fill="#ff0000" >
                <el-radio :label="roomType.id" class="contract-data-version-radio">{{$t('selectedVersion')}} ({{bindUpdatedAt(roomType.updatedAt)}})</el-radio>
              </el-radio-group>
            </div>
          </div>
        </td>
        <td width="15%">
          <div class="el-input el-input--small">
            <input placeholder="-"
                   type="number"
                   class="cutoff-date el-input__inner"
                   :class="{ 'input-disabled': isInputDisable(roomType) }"
                   :disabled="isInputDisable(roomType)"
                   v-model="roomType.cutoffDate"
                   @input="onApplyRoomTypeChange"/>
          </div>
        </td>
        <td width="15%">
          <div class="el-input el-input--small">
            <input placeholder="-"
                   type="number"
                   class="allotment el-input__inner"
                   :class="{ 'input-disabled': isInputDisable(roomType) }"
                   :disabled="isInputDisable(roomType)"
                   v-model="roomType.allotment"
                   @input="onApplyRoomTypeChange"/>
          </div>
        </td>
      </tr>
      <tr v-if="promotionRoomTypeListDataSource.length === 0"
          class="table-apply-room-type-body">
        <td colspan="4" align="center" style="font-style: italic; color: #cfc4cf">{{ $t('noData') }}</td>
      </tr>
    </table>
    <div>
      <el-form-item>
        <el-checkbox v-model="isShowDisableRoomType">
          {{$t('showDisableRoomType')}}
        </el-checkbox>
      </el-form-item>
    </div>
  </div>
</template>

<script>
import i18nMessages from '@/translations/SpecialOffer/components/TabSpecialOfferPromotionComponent.i18n'
import { STATUS } from '@/configs/constant'
import {
  getTableDataSource
} from '@/services/special-offer-service'
import { get } from 'lodash'
import {
  DATA_VERSION,
  isUpdatedData,
  isDeletedData,
  getSelectedDataListByVersion,
  getDataCheckList
} from '@/services/version-service'

export default {
  name: 'PromotionApplyRoomTypeComponent',
  i18n: { messages: i18nMessages },
  components: {},
  props: {
    selectedPromotionId: {
      type: String,
      default: ''
    },
    specialOfferPromotionSelected: {
      type: Object,
      default: () => {
        return {}
      }
    },
    promotionAllotment: {
      type: Array,
      default: () => {
        return []
      }
    },
    roomTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    promotionList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    selectedPromotionId: function (value) {
      this._initData(value)
    }
  },
  data () {
    return {
      STATUS,
      DATA_VERSION,
      isUpdatedData,
      isDeletedData,
      promotionRoomTypeListDataSource: [],
      promotionRoomTypeList: [],
      specialOfferPromotionId: '',
      isEnableAllotment: false,
      isShowDisableRoomType: false,
      applyRoomTypeCheckboxList: []
    }
  },
  created: function () {
    this.specialOfferPromotionId = get(this.specialOfferPromotionSelected, 'id', '')
    this._initData(this.selectedPromotionId)
  },
  methods: {
    _initData: function (selectedPromotionId) {
      this.promotionRoomTypeList = this._getPromotionRoomTypeList(selectedPromotionId)

      const promotionApplyRoomTypeList = this._preparePromotionApplyRoomTypeList(selectedPromotionId)
      const promotionRoomTypeListDataSource = getTableDataSource(this.promotionRoomTypeList, promotionApplyRoomTypeList)

      this.promotionRoomTypeListDataSource = promotionRoomTypeListDataSource.sort((a, b) => {
        return (a.isEnable < b.isEnable) ? 1 : (a.isEnable === b.isEnable) ? ((a.name > b.name) ? 1 : -1) : -1
      })

      this.isEnableAllotment = Boolean(get(this.specialOfferPromotionSelected, 'isEnableAllotment', 0))

      const isSelectNewPromotion = (this.specialOfferPromotionId === '' || selectedPromotionId !== this.specialOfferPromotionId)
      this.applyRoomTypeCheckboxList = getDataCheckList(this.promotionRoomTypeListDataSource, promotionApplyRoomTypeList, isSelectNewPromotion)

      this.onApplyRoomTypeChange()
    },
    _preparePromotionApplyRoomTypeList: function (selectedPromotionId) {
      if (selectedPromotionId !== this.specialOfferPromotionId) {
        return []
      }

      const promotionApplyRoomTypeList = get(this.specialOfferPromotionSelected, 'roomTypeList', [])
      const dataList = promotionApplyRoomTypeList.map((promotionRoomType) => {
        const roomTypeSourceData = this.promotionRoomTypeList.find(roomType => roomType.id === promotionRoomType.id)

        let roomTypeNameSourceData = (!roomTypeSourceData) ? '' : roomTypeSourceData.name
        const roomTypeUpdatedAtSourceData = (!roomTypeSourceData) ? undefined : roomTypeSourceData.updatedAt
        const isEnableRoomTypeSourceData = (!roomTypeSourceData) ? 1 : roomTypeSourceData.isEnable
        const promotionRoomTypeName = (promotionRoomType.name === '') ? roomTypeNameSourceData : promotionRoomType.name

        if (!roomTypeSourceData) {
          roomTypeNameSourceData = promotionRoomTypeName
        }

        const result = {
          id: promotionRoomType.id,
          name: (!promotionRoomType.updatedAt) ? roomTypeNameSourceData : promotionRoomTypeName,
          allotment: promotionRoomType.allotment,
          cutoffDate: promotionRoomType.cutoffDate,
          updatedAt: (!promotionRoomType.updatedAt) ? roomTypeUpdatedAtSourceData : promotionRoomType.updatedAt,
          isEnable: isEnableRoomTypeSourceData
        }

        return result
      })

      return dataList
    },
    _getPromotionRoomTypeList: function (selectedPromotionId) {
      const promotion = this.promotionList.find(promotion => Number(promotion.id) === Number(selectedPromotionId))
      const promotionRoomTypeIdList = get(promotion, 'roomTypeIdList', undefined)

      if (promotionRoomTypeIdList === undefined) {
        return this.roomTypeList
      }

      const applyRoomTypeList = this.roomTypeList.filter(roomType => {
        return promotionRoomTypeIdList.includes(roomType.id)
      })

      return applyRoomTypeList
    },
    onApplyRoomTypeChange: function () {
      const roomTypeListResult = getSelectedDataListByVersion(
        this.applyRoomTypeCheckboxList,
        this.promotionRoomTypeListDataSource,
        this.promotionRoomTypeList
      )

      const applyRoomTypeList = roomTypeListResult.map((roomType) => {
        const promotionRoomTypeData = this.promotionRoomTypeListDataSource.find(promotionRoomType => promotionRoomType.id === roomType.id)
        const allotment = (this.isEnableAllotment) ? promotionRoomTypeData.allotment : ''
        const cutoffDate = (this.isEnableAllotment) ? promotionRoomTypeData.cutoffDate : ''

        const roomTypeData = {
          allotment: (!promotionRoomTypeData) ? '' : allotment,
          cutoffDate: (!promotionRoomTypeData) ? '' : cutoffDate
        }

        const result = Object.assign({}, roomType, roomTypeData)
        return result
      })

      const promotionApplyRoomType = {
        applyRoomTypeList: applyRoomTypeList,
        isEnableAllotment: this.isEnableAllotment
      }

      this.$emit('onApplyRoomTypeChange', promotionApplyRoomType)
    },
    isInputDisable: function (roomType) {
      return (!this.isEnableAllotment || this.isRoomTypeDisable(roomType))
    },
    isRoomTypeDisable: function (roomType) {
      return (roomType.isEnable === STATUS.DISABLE)
    },
    showRoomTypeDisable: function (roomType) {
      return (roomType.isEnable === STATUS.DISABLE && this.isShowDisableRoomType === true)
    },
    bindLatestUpdatedAt: function (contractPromotionId) {
      const roomType = this.roomTypeList.find(item => item.id === contractPromotionId)
      if (roomType === undefined) {
        return '-'
      }

      const date = new Date(roomType.updatedAt)
      return this.$d(date, 'long')
    },
    bindUpdatedAt: function (updatedDate) {
      if (updatedDate === undefined) {
        return '-'
      }

      const date = new Date(updatedDate)
      return this.$d(date, 'long')
    }
  }
}
</script>

<style scoped>
  .label-contract {
    font-weight: bold;
    margin: 10px 0;
  }

  .table-apply-room-type {
    width: 100%;
    margin-bottom: 22px;
  }

  .table-apply-room-type-header td {
    padding: 10px;
    border-bottom: 1px #ddd solid;
    color: #2476e4;
    background-color: #eeeeee;
    font-size: 14px;
    font-weight: 500;
  }

  .table-apply-room-type-body td {
    padding: 10px;
    border-bottom: 1px #ddd solid;
    font-size: 14px;
  }

  .cutoff-date.el-input__inner {
    text-align: right;
    padding: 0px !important;
  }

  .allotment.el-input__inner {
    text-align: right;
    padding: 0px !important;
  }

  .input-disabled {
    background-color: #eeeeee !important;
    color: #bababa;
  }

  .row-disabled {
    background-color: #eeeeee !important;
    color: #bababa;
  }
</style>
